var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSunSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M361.5,1.2c5,2.1,8.6,6.6,9.6,11.9L391,121l107.9,19.8c5.3,1,9.8,4.6,11.9,9.6c2.1,5,1.5,10.7-1.6,15.2 L446.9,256l62.3,90.3c3.1,4.5,3.7,10.2,1.6,15.2s-6.6,8.6-11.9,9.6L391,391l-19.9,107.9c-1,5.3-4.6,9.8-9.6,11.9 c-5,2.1-10.7,1.5-15.2-1.6L256,446.9l-90.3,62.3c-4.5,3.1-10.2,3.7-15.2,1.6s-8.6-6.6-9.6-11.9L121,391L13.1,371.1 c-5.3-1-9.8-4.6-11.9-9.6s-1.5-10.7,1.6-15.2L65.1,256L2.8,165.7c-3.1-4.5-3.7-10.2-1.6-15.2s6.6-8.6,11.9-9.6L121,121l19.9-107.9 c1-5.3,4.6-9.8,9.6-11.9s10.7-1.5,15.2,1.6L256,65.1l90.3-62.3C350.8-0.3,356.5-0.9,361.5,1.2z M160,256c0-53,43-96,96-96 s96,43,96,96s-43,96-96,96S160,309,160,256z M384,256c0-70.7-57.3-128-128-128s-128,57.3-128,128s57.3,128,128,128 S384,326.7,384,256z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunSolid);
export default __webpack_public_path__ + "static/media/sun-solid.3667706c67424124492449a67fe4d975.svg";
export { ForwardRef as ReactComponent };